import { MARKUP_RULES } from "./rules.js";
/** Default options */
export const MARKUP_OPTIONS = {
    context: "block",
    rules: MARKUP_RULES,
    rel: undefined,
    base: undefined,
    schemes: undefined,
    hosts: undefined,
};
